<template>
  <div class="page-card">
    <div class="page-header">
      <h2 class="page-title">{{ isEdit ? '编辑通告' : '发送通告' }}</h2>
      <el-button @click="goBack">返回</el-button>
    </div>

    <el-radio-group v-if="!isEdit" v-model="form.publishType" class="publish-type-group">
      <el-radio-button label="platform">发送通告（平台身份）</el-radio-button>
      <el-radio-button label="proxy">代发通告（选择商家）</el-radio-button>
    </el-radio-group>

    <el-form ref="formRef" :model="form" label-width="120px" class="publish-form">
      <el-form-item v-if="form.publishType === 'platform'" label="主题商家" required>
        <el-input v-model="form.subjectMerchantName" placeholder="请输入主题商家名称" maxlength="200" />
      </el-form-item>

      <el-form-item v-if="form.publishType === 'proxy'" label="代发商家" required>
        <el-select
          v-model="form.merchantUserId"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="搜索商家名称/手机号"
          :remote-method="searchMerchants"
          :loading="merchantLoading"
          style="width: 360px"
          @visible-change="handleMerchantVisible"
        >
          <el-option
            v-for="item in merchantOptions"
            :key="item.userId"
            :label="merchantOptionLabel(item)"
            :value="String(item.userId)"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="通告标题" required>
        <el-input v-model="form.title" placeholder="请输入通告标题" maxlength="200" />
      </el-form-item>

      <el-form-item label="通告类型" required>
        <el-select v-model="noticeTypeList" multiple placeholder="请选择通告类型" style="width: 100%">
          <el-option v-for="item in noticeTypeOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item label="招募人数" required>
        <el-input-number v-model="form.recruitCount" :min="1" :max="9999" />
      </el-form-item>

      <el-form-item label="工作城市" required>
        <el-cascader
          v-model="regionCodes"
          :options="regionOptions"
          :props="regionCascaderProps"
          filterable
          clearable
          placeholder="请选择省市区"
          style="width: 100%"
          @change="handleRegionChange"
        />
      </el-form-item>

      <el-form-item label="工作区域" required>
        <el-input v-model="form.locationDetail" placeholder="请输入详细地址" />
      </el-form-item>

      <el-form-item label="活动开始" required>
        <el-date-picker
          v-model="form.activityStartAt"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
        />
      </el-form-item>

      <el-form-item label="活动结束">
        <el-date-picker
          v-model="form.activityEndAt"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束时间"
        />
      </el-form-item>

      <el-form-item label="报名截止" required>
        <el-date-picker
          v-model="form.signupDeadlineAt"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择截止时间"
        />
      </el-form-item>

      <el-form-item label="性别要求">
        <el-select v-model="form.genderRequirement" style="width: 160px">
          <el-option label="不限" :value="0" />
          <el-option label="仅男" :value="1" />
          <el-option label="仅女" :value="2" />
        </el-select>
      </el-form-item>

      <el-form-item label="年龄范围">
        <el-input-number v-model="form.ageMin" :min="0" :max="100" placeholder="下限" />
        <span class="range-sep">-</span>
        <el-input-number v-model="form.ageMax" :min="0" :max="100" placeholder="上限" />
      </el-form-item>

      <el-form-item label="身高范围(cm)">
        <el-input-number v-model="form.heightMin" :min="0" :precision="1" />
        <span class="range-sep">-</span>
        <el-input-number v-model="form.heightMax" :min="0" :precision="1" />
      </el-form-item>

      <el-form-item label="体重范围(kg)">
        <el-input-number v-model="form.weightMin" :min="0" :precision="1" />
        <span class="range-sep">-</span>
        <el-input-number v-model="form.weightMax" :min="0" :precision="1" />
      </el-form-item>

      <el-form-item label="报酬金额" required>
        <el-input v-model="form.salaryDesc" placeholder="请输入报酬金额" />
      </el-form-item>

      <el-form-item label="风格要求">
        <el-input v-model="form.styleRequirement" type="textarea" :rows="2" />
      </el-form-item>

      <el-form-item label="技能要求">
        <el-input v-model="form.skillRequirement" type="textarea" :rows="2" />
      </el-form-item>

      <el-form-item label="商家补充">
        <el-input v-model="form.merchantSupportDesc" type="textarea" :rows="3" />
      </el-form-item>

      <el-form-item label="报名须知">
        <el-input v-model="form.signupNotice" type="textarea" :rows="3" />
      </el-form-item>

      <el-form-item label="素材图片">
        <el-upload
          list-type="picture-card"
          :file-list="imageFileList"
          :http-request="uploadImage"
          :on-remove="handleImageRemove"
          accept="image/*"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="submitting" @click="submitForm">{{ isEdit ? '保存' : '发布通告' }}</el-button>
        <el-button @click="goBack">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getOpsTaxonomies } from '../../../api/opsTaxonomy'
import { getMerchantUsers } from '../../../api/platformManage'
import { getAdminCastingNoticeDetail, getCastingNoticeRegions, publishCastingNotice, updateCastingNotice } from '../../../api/castingNotice'
import request, { API_BASE_URL } from '../../../utils/request'
import { hasPermission } from '../../../utils/auth'

const municipalityCityAliases = ['市辖区']

function isMunicipalityProvince(province) {
  const cities = (province && province.cities) || []
  return cities.length === 1 && municipalityCityAliases.includes(cities[0].name)
}

function normalizeCityDisplayName(provinceName, cityName) {
  if (!cityName || municipalityCityAliases.includes(cityName)) {
    return provinceName || cityName || ''
  }
  return cityName
}

function mapRegionTree(list) {
  return (list || []).map(province => {
    if (isMunicipalityProvince(province)) {
      const city = province.cities[0]
      return {
        code: province.code,
        name: province.name,
        municipality: true,
        cityCode: city.code,
        children: (city.districts || []).map(district => ({
          code: district.code,
          name: district.name
        }))
      }
    }
    return {
      code: province.code,
      name: province.name,
      children: (province.cities || []).map(city => ({
        code: city.code,
        name: normalizeCityDisplayName(province.name, city.name),
        children: (city.districts || []).map(district => ({
          code: district.code,
          name: district.name
        }))
      }))
    }
  })
}

function normalizeRegionText(value) {
  return String(value || '')
    .trim()
    .replace(/\s+/g, '')
    .replace(/[／]/g, '/')
    .replace(/[—－-]/g, '/')
}

function isSameRegionName(left, right) {
  return normalizeRegionText(left) === normalizeRegionText(right)
}

function findRegionCodesByNames(workCity, workArea, regionOptions) {
  const cityTokens = normalizeRegionText(workCity).split('/').filter(Boolean)
  const areaText = normalizeRegionText(workArea)
  if (!cityTokens.length && !areaText) {
    return []
  }
  for (const province of regionOptions || []) {
    if (province.municipality) {
      const provinceMatched = !cityTokens.length || cityTokens.some(token => isSameRegionName(token, province.name))
      if (!provinceMatched) {
        continue
      }
      const district = (province.children || []).find(item => {
        if (areaText && isSameRegionName(item.name, areaText)) return true
        return cityTokens.some(token => isSameRegionName(token, item.name))
      })
      if (district) {
        return [province.code, district.code]
      }
      continue
    }
    const provinceMatched = cityTokens.length < 2 || isSameRegionName(cityTokens[0], province.name)
    if (!provinceMatched) {
      continue
    }
    for (const city of province.children || []) {
      const cityMatched = cityTokens.length >= 2
        ? isSameRegionName(cityTokens[cityTokens.length - 1], city.name)
        : cityTokens.length === 1
          ? isSameRegionName(cityTokens[0], city.name)
          : false
      if (!cityMatched) {
        continue
      }
      const district = (city.children || []).find(item => isSameRegionName(item.name, areaText))
      if (district) {
        return [province.code, city.code, district.code]
      }
    }
  }
  return []
}

function defaultForm() {
  return {
    publishType: 'platform',
    subjectMerchantName: '',
    merchantUserId: '',
    title: '',
    recruitCount: 1,
    workCity: '',
    workArea: '',
    activityStartAt: '',
    activityEndAt: '',
    signupDeadlineAt: '',
    ageMin: null,
    ageMax: null,
    genderRequirement: 0,
    heightMin: null,
    heightMax: null,
    weightMin: null,
    weightMax: null,
    styleRequirement: '',
    skillRequirement: '',
    experienceRequired: 0,
    salaryDesc: '',
    workDurationDesc: '',
    locationDetail: '',
    merchantSupportDesc: '',
    signupNotice: '',
    mediaUrls: []
  }
}

export default {
  name: 'CastingNoticePublishPage',
  data() {
    return {
      form: defaultForm(),
      noticeTypeList: [],
      noticeTypeOptions: [],
      regionCodes: [],
      regionOptions: [],
      regionCascaderProps: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      merchantOptions: [],
      merchantLoading: false,
      imageFileList: [],
      submitting: false
    }
  },
  computed: {
    isEdit() {
      return Boolean(this.$route.query.id)
    },
    canPublish() {
      return hasPermission('casting_notice:publish')
    }
  },
  watch: {
    'form.publishType'(value) {
      if (value === 'proxy') {
        this.loadMerchants('')
      } else {
        this.form.merchantUserId = ''
        this.merchantOptions = []
      }
    }
  },
  created() {
    if (!this.canPublish) {
      this.$message.error('无发送通告权限')
      this.goBack()
      return
    }
    this.initPage()
  },
  methods: {
    async initPage() {
      await Promise.all([this.loadNoticeTypes(), this.fetchRegions()])
      if (this.isEdit) {
        await this.loadDetail(this.$route.query.id)
      }
    },
    async loadNoticeTypes() {
      const list = await getOpsTaxonomies({ businessType: 1, status: 1 }).catch(() => [])
      this.noticeTypeOptions = (list || []).map(item => item.taxonomyName).filter(Boolean)
    },
    async fetchRegions() {
      try {
        const data = await getCastingNoticeRegions()
        this.regionOptions = mapRegionTree(Array.isArray(data) ? data : [])
      } catch (error) {
        this.regionOptions = []
        this.$message.error(error.message || '省市区数据加载失败')
      }
    },
    async loadDetail(id) {
      const detail = await getAdminCastingNoticeDetail(id)
      this.form.publishType = detail.publishSource === 3 ? 'proxy' : 'platform'
      this.form.subjectMerchantName = detail.subjectMerchantName || ''
      this.form.merchantUserId = detail.merchantUserId ? String(detail.merchantUserId) : ''
      this.form.title = detail.title || ''
      this.noticeTypeList = (detail.noticeType || '').split(',').map(item => item.trim()).filter(Boolean)
      this.form.recruitCount = detail.recruitCount || 1
      this.form.workCity = detail.workCity || ''
      this.form.workArea = detail.workArea || ''
      this.form.activityStartAt = detail.activityStartAt || ''
      this.form.activityEndAt = detail.activityEndAt || ''
      this.form.signupDeadlineAt = detail.signupDeadlineAt || ''
      this.form.ageMin = detail.ageMin
      this.form.ageMax = detail.ageMax
      this.form.genderRequirement = detail.genderRequirement == null ? 0 : detail.genderRequirement
      this.form.heightMin = detail.heightMin
      this.form.heightMax = detail.heightMax
      this.form.weightMin = detail.weightMin
      this.form.weightMax = detail.weightMax
      this.form.styleRequirement = detail.styleRequirement || ''
      this.form.skillRequirement = detail.skillRequirement || ''
      this.form.salaryDesc = detail.salaryDesc || ''
      this.form.locationDetail = detail.locationDetail || ''
      this.form.merchantSupportDesc = detail.merchantSupportDesc || ''
      this.form.signupNotice = detail.signupNotice || ''
      this.form.mediaUrls = detail.mediaUrls || []
      this.syncRegionCodesFromWorkLocation()
      this.imageFileList = (detail.mediaUrls || []).map((url, index) => ({
        name: `image-${index}`,
        url: this.fullUrl(url)
      }))
      if (this.form.merchantUserId) {
        this.merchantOptions = [{
          userId: String(this.form.merchantUserId),
          merchantName: detail.merchantDisplayName || '已选商家'
        }]
      }
      if (this.form.publishType === 'proxy') {
        const preserved = this.merchantOptions.slice()
        await this.loadMerchants('')
        const merged = new Map()
        preserved.forEach(item => merged.set(String(item.userId), item))
        this.merchantOptions.forEach(item => merged.set(String(item.userId), item))
        this.merchantOptions = Array.from(merged.values())
      }
    },
    merchantOptionLabel(item) {
      const name = item.brandName || item.merchantName || item.mobile || item.userId
      return item.mobile ? `${name} (${item.mobile})` : name
    },
    normalizeMerchantOptions(list) {
      return (list || []).filter(item => {
        if (item.authStatus != null && Number(item.authStatus) !== 2) {
          return false
        }
        return item.mobile !== '19900000001'
      })
    },
    async loadMerchants(keyword) {
      this.merchantLoading = true
      try {
        const data = await getMerchantUsers({
          keyword: keyword ? keyword.trim() : undefined,
          userStatus: 1,
          page: 1,
          pageSize: 10
        })
        this.merchantOptions = this.normalizeMerchantOptions(data && data.records)
      } finally {
        this.merchantLoading = false
      }
    },
    searchMerchants(keyword) {
      this.loadMerchants(keyword)
    },
    handleMerchantVisible(visible) {
      if (visible && this.form.publishType === 'proxy' && !this.merchantLoading) {
        this.loadMerchants('')
      }
    },
    syncRegionCodesFromWorkLocation() {
      const codes = findRegionCodesByNames(this.form.workCity, this.form.workArea, this.regionOptions)
      if (!codes.length) {
        return
      }
      this.regionCodes = codes
      this.handleRegionChange(codes)
    },
    handleRegionChange(codes) {
      this.regionCodes = Array.isArray(codes) ? codes : []
      const selection = this.resolveRegionSelection(this.regionCodes)
      this.form.workCity = this.formatWorkCity(selection)
      this.form.workArea = selection.districtName
    },
    resolveRegionSelection(codes) {
      const result = {
        provinceName: '',
        cityName: '',
        districtName: ''
      }
      if (!codes || !codes.length) {
        return result
      }
      const province = (this.regionOptions || []).find(item => item.code === codes[0])
      if (!province) {
        return result
      }
      result.provinceName = province.name
      if (province.municipality && codes.length === 2) {
        result.cityName = province.name
        const district = (province.children || []).find(item => item.code === codes[1])
        if (district) {
          result.districtName = district.name
        }
        return result
      }
      const city = (province.children || []).find(item => item.code === codes[1])
      if (!city) {
        return result
      }
      result.cityName = city.name
      const district = (city.children || []).find(item => item.code === codes[2])
      if (district) {
        result.districtName = district.name
      }
      return result
    },
    formatWorkCity(selection) {
      if (!selection || !selection.provinceName) {
        return ''
      }
      if (!selection.cityName || selection.cityName === selection.provinceName) {
        return selection.provinceName
      }
      return `${selection.provinceName}/${selection.cityName}`
    },
    fullUrl(url) {
      if (!url) return ''
      if (url.startsWith('http://') || url.startsWith('https://')) return url
      if (url.startsWith('/uploads/')) {
        return `${API_BASE_URL}/api/common/file/${url.replace('/uploads/', '')}`
      }
      return url.startsWith('/') ? `${API_BASE_URL}${url}` : url
    },
    async uploadImage(option) {
      const formData = new FormData()
      formData.append('file', option.file)
      const result = await request({
        url: '/api/common/upload',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      const url = result.url || result
      this.form.mediaUrls.push(url)
      option.onSuccess(result)
    },
    handleImageRemove(file) {
      const url = file.url && file.url.includes('/api/common/file/')
        ? `/uploads/${file.url.split('/api/common/file/')[1]}`
        : file.url
      this.form.mediaUrls = this.form.mediaUrls.filter(item => this.fullUrl(item) !== file.url && item !== url)
    },
    buildPayload() {
      if (!this.noticeTypeList.length) {
        throw new Error('请选择通告类型')
      }
      const selection = this.resolveRegionSelection(this.regionCodes)
      this.form.workCity = this.formatWorkCity(selection)
      this.form.workArea = selection.districtName
      if (!selection.provinceName || !selection.cityName || !selection.districtName) {
        throw new Error('请选择工作城市')
      }
      if (this.form.publishType === 'platform' && !this.form.subjectMerchantName.trim()) {
        throw new Error('请填写主题商家')
      }
      if (this.form.publishType === 'proxy' && !this.form.merchantUserId) {
        throw new Error('请选择代发商家')
      }
      return {
        ...this.form,
        noticeType: this.noticeTypeList.join(',')
      }
    },
    async submitForm() {
      if (this.submitting) return
      try {
        const payload = this.buildPayload()
        this.submitting = true
        if (this.isEdit) {
          await updateCastingNotice(this.$route.query.id, payload)
          this.$message.success('保存成功')
          this.$router.push(`/casting/manage/${this.$route.query.id}`)
          return
        }
        await publishCastingNotice(payload)
        this.$message.success('发布成功')
        this.goBack()
      } catch (error) {
        this.$message.error(error.message || '提交失败')
      } finally {
        this.submitting = false
      }
    },
    goBack() {
      this.$router.push('/casting/hall')
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.publish-type-group {
  margin-bottom: 20px;
}

.publish-form {
  max-width: 880px;
}

.range-sep {
  margin: 0 8px;
  color: #909399;
}
</style>
